import { render, staticRenderFns } from "./combinedData.vue?vue&type=template&id=17790fbe&scoped=true"
import script from "./combinedData.vue?vue&type=script&lang=js"
export * from "./combinedData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17790fbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/mall-super-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17790fbe')) {
      api.createRecord('17790fbe', component.options)
    } else {
      api.reload('17790fbe', component.options)
    }
    module.hot.accept("./combinedData.vue?vue&type=template&id=17790fbe&scoped=true", function () {
      api.rerender('17790fbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/devconfig/combinedData.vue"
export default component.exports